import React, {useState, useEffect} from 'react'
import {buildImageObj} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'
import DropdownSelect from './dropdownSelect'
import PortableText from './portableText'
import {isUserInRegion} from '../services/auth'
import { Player } from 'video-react'
import 'video-react/dist/video-react.css'

const AccordionSubSection = ({items, userRegion}) => {
    let filteredItem = items.filter(item => isUserInRegion(userRegion, item.region))
    if(filteredItem.length <=0) return ''

    return (
        <div className="pt-3">
            <div className="row">

                {/* {console.log('---> items > sub-section: ', items)} */}

                {
                    filteredItem &&
                    filteredItem.map((subSection, i) => (
                        <div key={i} className="col-12 col-md-6">
                            <h5>{subSection.title}</h5>

                            <div className="row mx-0">
                                {
                                    subSection.files && subSection.files.length === 1 &&
                                    subSection.files.map((image, i) => {
                                        if(image && image.asset && image._type === 'mainImage'){
                                            return <img key={i} className="col-12 px-0" src={imageUrlFor(buildImageObj(image)).fit('crop').url()} alt={image.alt || ''} />
                                        }
                                        if(image && image.file.asset && image._type === 'video'){
                                            return  <div key={i} className="col-12 px-0">
                                                        <Player
                                                            poster={(image.thumbnail && image.thumbnail.asset) ? image.thumbnail.asset.url : ''}
                                                        >
                                                            <source src={(image.file && image.file.asset) ? image.file.asset.url : ''} />
                                                        </Player>
                                                        <div>{image.title || ''}</div>
                                                    </div>
                                        }
                                    })
                                }
                                {
                                    subSection.files && subSection.files.length === 2 &&
                                    subSection.files.map((image, i) => {
                                        if(image && image.asset && image._type === 'mainImage'){
                                            return <div key={i} className="col-6 col-md-6 p-1"><img src={imageUrlFor(buildImageObj(image)).fit('crop').url()} alt={image.alt || ''} /><div>{image.caption || ''}</div></div>
                                        }
                                        if(image && image.file.asset && image._type === 'video'){
                                            return  <div key={i} className="col-6 col-md-6 p-1">
                                                        <Player
                                                            poster={(image.thumbnail && image.thumbnail.asset) ? image.thumbnail.asset.url : ''}
                                                        >
                                                            <source src={(image.file && image.file.asset) ? image.file.asset.url : ''} />
                                                        </Player>
                                                        <div>{image.title || ''}</div>
                                                    </div>
                                        }
                                    })
                                }
                                {
                                    subSection.files && subSection.files.length > 2 &&
                                    subSection.files.map((image, i) => {
                                        if(image && image.asset && image._type === 'mainImage'){
                                            return <div key={i} className="col-6 col-md-4 p-1"><img src={imageUrlFor(buildImageObj(image)).fit('crop').url()} alt={image.alt || ''} /><div>{image.caption || ''}</div></div>
                                        }
                                        if(image && image.file.asset && image._type === 'video'){
                                            return  <div key={i} className="col-6 col-md-4 p-1">
                                                        <Player
                                                            poster={(image.thumbnail && image.thumbnail.asset) ? image.thumbnail.asset.url : ''}
                                                        >
                                                            <source src={(image.file && image.file.asset) ? image.file.asset.url : ''} />
                                                        </Player>
                                                        <div>{image.title || ''}</div>
                                                    </div>
                                        }
                                    })
                                }
                            </div>

                            {
                                subSection._rawDecription && 
                                <div className="pt-2">
                                    <PortableText blocks={subSection._rawDecription} />
                                </div>
                            }

                            <div className="pt-2">
                                <DropdownSelect items={subSection.sectionLinks} userRegion={userRegion} />
                            </div>
                        </div>
                    ))
                }

            </div>
        </div>
    )
}

export default AccordionSubSection